import pageStyle from "./index.module.less";
import Result from "@/views/ticket/components/result";
import QuickReply from "@/components/quickReply";
import ReplyEmail from "@/components/ticket/replayEmail";
import * as service from "@/views/ticket/service";

export default {
    name: "Reply",
    props: {
        id: {
            type: [String, Number],
            default: 0
        },
        onSubmit: Function,
        lang: String
    },
    components: { Result, QuickReply, ReplyEmail },
    data() {
        return {
            pageStyle,
            loading: false,
            result: {
                answer: ""
            },
            activeName: "game",
            value: "",
            insertEmail: "",
            insertLanguage: [
                {
                    id: 0,
                    name: "other"
                },
                {
                    id: 1,
                    name: "arabic"
                }
            ],
            isTranslate: false,
            copyAnswer: ""
        };
    },
    computed: {
        canSubmit() {
            const { result, answer, mail_content, mail_addr } = this.result;
            return !!((result && answer) || (result && (mail_content || mail_addr)));
        }
    },
    methods: {
        async submit() {
            this.loading = true;
            let result = {
                ...this.result,
                mail_content: this.result.mail_content ? this.result.mail_content.replace(/\n/g, "") : this.result.mail_content
            };
            try {
                await this.onSubmit(result);
            } catch (err) {
                console.error(err);
            }
            this.loading = false;
        },
        getStatementContent(value) {
            if (this.activeName == "game") {
                if (typeof this.result.answer == "undefined") {
                    this.result = {
                        answer: ""
                    };
                }
                this.result.answer += value;
            } else {
                this.insertEmail = value;
            }
        },
        tabHandleClick(tab) {
            this.activeName = tab.name;
            this.result = {
                answer: "",
                mail_content: ""
            };
            if (tab.name == "email") {
                // 触发子组件completeBtn方法
                this.$refs.ReplyEmail.$emit("completeBtn");
            }
        },
        complete(form) {
            if (form) {
                this.result = form;
            } else {
                this.result = {};
            }
        },
        async switchChange() {
            if (!this.result.answer) {
                this.isTranslate = false;
                return false;
            }
            if (this.isTranslate) {
                this.copyAnswer = this.result.answer;
                const query = {
                    content: this.result.answer,
                    from: "",
                    to: this.lang
                };
                const answer = await service.translate(query);
                this.result.answer = answer.output;
            } else {
                this.result.answer = this.copyAnswer;
                this.copyAnswer = "";
            }
        }
    },
    watch: {
        id() {
            this.result = {};
        }
    }
};
